<template>
    <div class="px-2 mx-auto mt-4 md:mt-12">
        <spinner v-if="!kpis" />

        <div
            v-if="kpis"
            class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 mx-auto max-w-7xl justify-center gap-2"
        >
            <MetricCard
                :label="$t('Users')"
                :inLast30Days="kpis.inLast30Days.users"
                :value="kpis.users"
                to="/users"
            />
            <MetricCard
                :label="$t('Thanks Cards')"
                :inLast30Days="kpis.inLast30Days.posts"
                :value="kpis.posts"
                to="/thanks-cards"
            />
            <MetricCard
                class="hidden"
                :label="$t('ThanksCard Views')"
                :inLast30Days="kpis.inLast30Days.postViewed"
                :value="kpis.postViewed"
                to="/thanks-cards"
            />
            <MetricCard
                :label="$t('Givs')"
                :inLast30Days="kpis.inLast30Days.givs"
                :value="kpis.givs"
                to="/givs"
            />
            <MetricCard
                :label="$t('Comments')"
                :inLast30Days="kpis.inLast30Days.comments"
                :value="kpis.comments"
                to="/comments"
            />
            <MetricCard
                :label="$t('metric-sendRequests')"
                :inLast30Days="kpis.inLast30Days.sendRequests"
                :value="kpis.sendRequests"
                to="/"
            />
            <MetricCard
                :label="$t('metric-receiveRequests')"
                :inLast30Days="kpis.inLast30Days.receiveRequests"
                :value="kpis.receiveRequests"
                to="/"
            />
            <MetricCard
                :label="$t('Likes')"
                :inLast30Days="kpis.inLast30Days.likes"
                :value="kpis.likes"
                to="/"
            />
            <MetricCard
                :label="$t('Reactions')"
                :inLast30Days="kpis.inLast30Days.commentReactions"
                :value="kpis.commentReactions"
                to="/"
            />
            <MetricCard
                :label="$t('Areas')"
                :inLast30Days="kpis.inLast30Days.areas"
                :value="kpis.areas"
                to="/areas"
            />
            <MetricCard
                :label="$t('Skills')"
                :inLast30Days="kpis.inLast30Days.skills"
                :value="kpis.skills"
                to="/skills"
            />
        </div>
        <div class="px-8 py-2 flex justify-end">
            <label class="flex items-center">
                <span class="mr-2">Cumulative</span>
                <a-switch :disabled="loading" v-model="aggregate" @change="onAggChange" />
            </label>
        </div>
        <div
            class="grid grid-cols-1 gap-x-2 gap-y-4 md:grid-cols-2 lg:grid-cols-3 w-full lg:px-8"
            v-if="!loading"
        >
            <div class="w-full" :key="idx" v-for="(kpi, idx) in metrics">
                <bar-chart
                    :options="{ ...chartOptions, ...kpi.options }"
                    :data="kpi"
                    :aggregate="aggregate"
                    style="height:300px"
                />
            </div>
        </div>
    </div>
</template>

<script>
//@Todo show charts
import MetricCard from '../components/MetricsCard'
import BarChart from '../components/charts/Bar'
import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes'
import 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.office'
import api from '../lib/api'
import _ from 'lodash'

export default {
    name: 'home',
    components: {
        MetricCard,
        BarChart,
    },
    data() {
        return {
            loading: true,
            kpis: null,
            aggregate: false,
            pastKpis: [],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    labels: {
                        boxWidth: 0,
                    },
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ],
                },
            },
            metrics: [],
        }
    },
    async mounted() {
        await api.sleep(1000)
        const res = await api.getKpisV2()
        this.kpis = res.stats
        this.pastKpis = res.pastKpis
        this.loading = false
        this.metrics = this.makeMetrics()
    },
    methods: {
        onAggChange: async function(val) {
            this.aggregate = val
            this.metrics = this.makeMetrics()
        },
        makeMetrics() {
            return Object.entries(this.pastKpis).map(([metric, v]) => {
                let val = v
                if (!this.aggregate) {
                    val = val.slice(0, 9)
                }
                let labels = val.map(v => v.month)
                let data
                if (this.aggregate) {
                    const valRev = _.reverse(val.map(v => v.count))
                    data = valRev.map((item, idx) => {
                        return valRev.slice(0, idx + 1).reduce((sum, curr) => curr + sum, 0)
                    })
                    labels = _.reverse(labels)
                } else {
                    data = val.map(v => v.count)
                }

                return {
                    label: this.$t(`metric-${metric}`),
                    data,
                    labels,
                    options: {
                        plugins: {
                            colorschemes: {
                                scheme: 'office.BlueII6',
                            },
                        },
                        scales: {
                            xAxes: [{ ticks: { reverse: !this.aggregate } }],
                            yAxes: [{ ticks: { beginAtZero: true } }],
                        },
                    },
                }
            })
        },
    },
}
</script>
